import distance from './distance';

export default function findNearestStation(userCoords, stations) {
  let nearestStation = '';
  let tempDistance = null;
  stations.forEach((station) => {
    let dist = distance(
      userCoords.latitude,
      userCoords.longitude,
      station.coordinate.latitude,
      station.coordinate.longitude,
      'K'
    );

    if (tempDistance) {
      if (dist < tempDistance) {
        nearestStation = station.key;
        tempDistance = dist;
      }
    } else {
      nearestStation = station.key;
      tempDistance = dist;
    }
  });

  return nearestStation;
}
